// @ts-strict-ignore
import {AfterViewInit, Component, ElementRef, Injector, ViewChild} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {NotificationService, SimUtilityService} from "@services";
import {Media} from "@models";
import {TranslateService} from "@ngx-translate/core";
import {Translations} from "@translations";

export interface DialogData_PowerPointDialogInput extends MatDialogDataBaseInput {
	media?: Media;
	mediaUrl?: string | File;
	mediaName?: string;
}

export interface DialogData_PowerPointDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-powerpoint-dialog",
	templateUrl: "./powerpoint-dialog.component.html",
	styleUrls: ["./powerpoint-dialog.component.scss"],
	standalone: false,
})
export class PowerpointDialogComponent
	extends BasicMaterialDialog<PowerpointDialogComponent, DialogData_PowerPointDialogInput, DialogData_PowerPointDialogOutput>
	implements AfterViewInit
{
	T = Translations;
	SimUtilityService = SimUtilityService;
	pageNum: number = 0;
	numberOfPowerPointPages: number = 0;
	@ViewChild("powerPointContainer", {static: false})
	powerPointContainer: ElementRef;
	public powerPointWidth: number;
	public powerPointHeight: number;
	public powerPointReady: boolean;
	powerPointLoaded: boolean;
	pptxLoadingError: Boolean;

	constructor(
		private _translate: TranslateService,
		_injector: Injector,
		private _simNotificationService: NotificationService,
	) {
		super(_injector);
	}

	powerPointError() {
		this._simNotificationService.notifyError(this._translate.instant(Translations.POWERPOINT_DIALOG_NOTIFYERROR));
		this.pptxLoadingError = true;
	}

	ngAfterViewInit() {
		const powerPointContainerClientRect = this.powerPointContainer.nativeElement?.getBoundingClientRect();
		this.powerPointWidth = powerPointContainerClientRect.width - 140;
		this.powerPointHeight = powerPointContainerClientRect.height;
		this.powerPointReady = true;
	}
}
